(function() {
  'use strict';

  function hasClass(element, className) {
    return (' ' + element.className + ' ').indexOf(' ' + className + ' ') !== -1;
  }

  function addClass(element, className) {
    if (!hasClass(element, className)) element.className += ' ' + className;
  }

  function removeClass(element, className) {
    var expression = new RegExp('(^|\\s)' + className + '(?:\\s|$)', 'g');
    element.className = element.className.replace(expression, ' ').replace(/^\s+|\s+$/g, '');
  }

  function trim(value) {
    return (value || '').replace(/^\s+|\s+$/g, '');
  }

  function closeSearch(root, focusButton) {
    var button = root.querySelector('.search__button');
    removeClass(root, 'ps-header-search-open');
    if (button) button.setAttribute('aria-expanded', 'false');
    if (focusButton && button && button.focus) {
      try { button.focus(); } catch (_error) {}
    }
  }

  function bindSearch(root) {
    var button = root.querySelector('.search__button');
    var input = root.querySelector('input[type="search"]');
    if (!button || !input || root.getAttribute('data-ps-cart-search-bound') === 'true') return;
    root.setAttribute('data-ps-cart-search-bound', 'true');
    button.setAttribute('aria-expanded', 'false');
    button.setAttribute('aria-controls', input.id);

    input.addEventListener('focus', function() {
      addClass(root, 'ps-header-search-open');
      button.setAttribute('aria-expanded', 'true');
    });

    button.addEventListener('click', function(event) {
      if (!hasClass(root, 'ps-header-search-open')) {
        event.preventDefault();
        addClass(root, 'ps-header-search-open');
        button.setAttribute('aria-expanded', 'true');
        try { input.focus(); } catch (_error) {}
      }
    });

    document.addEventListener('keydown', function(event) {
      if ((event.key === 'Escape' || event.keyCode === 27) && hasClass(root, 'ps-header-search-open')) {
        event.preventDefault();
        closeSearch(root, true);
      }
    });

    document.addEventListener('click', function(event) {
      if (!hasClass(root, 'ps-header-search-open')) return;
      if (root.contains && root.contains(event.target)) return;
      if (trim(input.value) !== '') return;
      closeSearch(root, false);
    });
  }

  function init() {
    var cartItems = document.querySelector('cart-items');
    function syncCartClearance() {
      if (!document.body || !cartItems) return;
      if (!hasClass(cartItems, 'is-empty') && cartItems.querySelector('.ps-cart-mobile-checkout')) {
        addClass(document.body, 'ps-cart-mobile-checkout-active');
      } else {
        removeClass(document.body, 'ps-cart-mobile-checkout-active');
      }
    }
    syncCartClearance();
    if (cartItems && typeof MutationObserver !== 'undefined') {
      new MutationObserver(syncCartClearance).observe(cartItems, {
        attributes: true,
        attributeFilter: ['class'],
        childList: true,
        subtree: true
      });
    }
    var roots = document.querySelectorAll('.ps-cart-header .header__search--mobile');
    var index = 0;
    for (index = 0; index < roots.length; index++) bindSearch(roots[index]);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
}());
